/** @jsxImportSource @emotion/react */

import { Undo2 as Undo2Icon } from 'lucide-react';
import { useLingui } from '@lingui/react/macro';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import history from 'modules/overlay-canvas/addons/history';

import UDIconButton from 'ud-ui/components/icon-button';
import UDTippy from 'ud-ui/components/tippy';
import { selectActiveModal } from 'modules/template-editor/store/editor/selectors';
import { useEditorManager } from 'modules/template-editor/ui/context';

export function Undo() {
  const { t } = useLingui();
  const activeModal = useSelector(selectActiveModal);
  const fabricManager = useEditorManager();
  const [isActive, setIsActive] = React.useState(history.isInit() ?? history.undoIsActive());

  const onClickUndo = () => {
    if (!fabricManager) return;
    history.undo();
  };

  useEffect(() => {
    history.history.subscribe(() => {
      setIsActive(history.undoIsActive());
    });
    history.index.subscribe(() => {
      setIsActive(history.undoIsActive());
    });
  }, []);

  return (
    <UDTippy disabled={Boolean(activeModal)} content={t({ message: 'Назад', context: 'undo' })} size="xs">
      <span style={{ display: 'inline-block' }}>
        <UDIconButton
          variant="ghost"
          icon={<Undo2Icon size={20} strokeWidth={1.5} />}
          onClick={onClickUndo}
          disabled={!isActive}
          tabIndex={0}
        />
      </span>
    </UDTippy>
  );
}
